module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f431.a582f38c.svg";